import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

const API_URL = process.env.REACT_APP_BASE_URL;
const TOKEN = "a94c7ac0083ae190f0fe61143a7547799b5334c4";

const headers = {
  Authorization: `Token ${TOKEN}`,
  "Content-Type": "application/json",
};



export const fetchCategories = createAsyncThunk(
  "category/fetchCategories",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              // Handle date range filters
              if (typeof filterValue === "object" && filterValue !== null) {
                if (filterField === "created_at") {
                  if (filterValue.from_date) {
                    params.append("created_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("created_at_to", filterValue.to_date);
                  }
                } else if (filterField === "updated_at") {
                  if (filterValue.from_date) {
                    params.append("updated_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("updated_at_to", filterValue.to_date);
                  }
                } else {
                  // Handle other object filters
                  Object.entries(filterValue).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== "") {
                      params.append(key, String(value));
                    }
                  });
                }
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await Axios.get(`${api.master.category.list}?${params.toString()}`);
      
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchCategories error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch category");
    }
  }
);

export const fetchCategoryById = createAsyncThunk(
  "category/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`${api.master.category.fetchCategoryById}/${id}`);
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch category by ID"
      );
    }
  }
);

export const fetchCategoryByDropDown = createAsyncThunk(
  "Category/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${api.master.category.fetchCategoryByDropDown}`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Category list"
      );
    }
  }
);

// Dropdown for enquiry/item details forms (non-master endpoint)
export const fetchCategoryDropdownForForms = createAsyncThunk(
  "Category/fetchCategoryDropdownForForms",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/category/dropdown/category_name/`);
      const data = Array.isArray(response.data)
        ? response.data
        : response.data?.data || response.data?.category_name || [];
      return data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Category dropdown"
      );
    }
  }
);

export const updateCategory = createAsyncThunk(
  "category/updateCategory",
  async ({ id, payload }: { id: any; payload: any }, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `${api.master.category.updateCategory}${id}`,
        payload
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update category");
    }
  }
);

export const updateStatusInCategory = createAsyncThunk(
  "category/updateStatusInCategory",
  async (categoryData: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: categoryData.is_active };
      const response: any = await Axios.patch(
        `${api.master.category.updateStatusInCategory}${categoryData.id}`,
        payload
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update status in category"
      );
    }
  }
);

export const addCategory = createAsyncThunk(
  "category/addCategory",
  async (categoryData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `${API_URL}${api.master.category.addCategory}`,
        categoryData
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add category");
    }
  }
);

export const deleteGp = createAsyncThunk(
  "category/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await Axios.delete(`${api.master.category.deleteCategory}${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const exportCategoryCSV = async () => {
//   const response = await Axios.get("/category/?export=csv", {
//     responseType: "blob",
//   });

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "category.csv",
//   };
// };
export const exportCategoryCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

 if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              // Handle date range filters
              if (typeof filterValue === "object" && filterValue !== null) {
                if (filterField === "created_at") {
                  if (filterValue.from_date) {
                    params.append("created_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("created_at_to", filterValue.to_date);
                  }
                } else if (filterField === "updated_at") {
                  if (filterValue.from_date) {
                    params.append("updated_at_from", filterValue.from_date);
                  }
                  if (filterValue.to_date) {
                    params.append("updated_at_to", filterValue.to_date);
                  }
                } else {
                  // Handle other object filters
                  Object.entries(filterValue).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== "") {
                      params.append(key, String(value));
                    }
                  });
                }
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

  const response = await Axios.get(`/master/category/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "category.csv",
  };
};
